// LOAD-BEARING SIDE-EFFECT IMPORT — do not delete as unused. Removing it
// breaks Rematch model-cluster init order for other modules in the cycle.
import '@/pages/api/scribeAPIV2';

import { useQueryKindeProperties } from '@/hooks/query/useQueryKindeProperties';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  type GetIntegrationOnboardingSessionsQueryParams,
  type SearchIntegrationOnboardingSessionsResponse,
} from '@heidi/integrations/connected-apps/contracts';
import { useQueryIntegrationOnboardingSessions as useQueryIntegrationOnboardingSessionsCore } from '@heidi/integrations/connected-apps/data';

export { GET_INTEGRATION_ONBOARDING_SESSIONS } from '@heidi/integrations/connected-apps/contracts';

/** Resolves the three gate terms the package can't reach and passes them in. */
export const useQueryIntegrationOnboardingSessions = <
  T = SearchIntegrationOnboardingSessionsResponse,
>({
  params,
  select,
  enabled,
}: {
  params: GetIntegrationOnboardingSessionsQueryParams;
  select?: (data: SearchIntegrationOnboardingSessionsResponse) => T;
  enabled?: boolean;
}) => {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: kindeProperties } = useQueryKindeProperties();
  const user = useQueryUser((data) => data.kinde_user_id);

  return useQueryIntegrationOnboardingSessionsCore({
    params,
    select,
    enabled,
    isAuthenticated,
    region: kindeProperties?.region,
    user,
  });
};
